import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from "@chakra-ui/react";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";

import "./main.css";
import App from '@pages/App';
import theme from "./theme/theme";
import "@lang/i18n"; // this has to be imported here 


// const stripePromise = loadStripe("pk_test_TYooMQauvdEDq54NiTphI7jx", {
//   locale: "fr"
// });

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={"Loading..."}>
      <ChakraProvider theme={theme}>
        {/* <Elements stripe={stripePromise}> */}
          <App />
        {/* </Elements> */}
      </ChakraProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

    